import React, { Component, PropTypes, Children } from 'react';

/** To be used in conjuction with UIDropdown */
class UIDropdownItem extends Component {
  handleSelection = (event) => {
    const {value, onSelection, toggleDropdown} = this.props;
    if (!!onSelection) {
      onSelection(value, event);
    }
    toggleDropdown();
  }

  render() {
    const {
      key,
      value,
      text,
      onClick,
      style,
      children
    } = this.props;

    const handleClick = onClick || this.handleSelection;

    return (
      <div onClick={handleClick}
           className="uiDropdownItem"
           style={style}
      >
        {children}
      </div>
    );
  }
}

export default UIDropdownItem;



// WEBPACK FOOTER //
// ./node_modules/shared-web/src/components/UIDropdownItem/index.js